import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import logo from '../../../../theme/images/logo.svg'
import { Card, Layout, LayoutHeader, LayoutBody, ResetPasswordForm } from '../../../components'
import styles from './ResetPasswordPage.module.scss'
import { useSelector } from 'react-redux'
import { userApiSelectors } from '../../../../modules/api/user'

type ResetPasswordPageParams = {
  token?: string
}

type ResetPasswordPageLocationState = {
  from?: string
}

type ResetPasswordPageProps = RouteComponentProps<ResetPasswordPageParams, {}, ResetPasswordPageLocationState>

const ResetPasswordPage = (props: ResetPasswordPageProps): JSX.Element => {
  const isAuthenticated = useSelector(userApiSelectors.isAuthenticated)
  const token = props.match.params.token ?? ''
  const from = props.location.state?.from ?? '/'

  return isAuthenticated ? (
    <Redirect to={from} />
  ) : (
    <div className={styles.root}>
      <Layout>
        <LayoutHeader>
          <div className={styles.header}>
            <img width="96px" src={logo} alt="reOS" />
          </div>
        </LayoutHeader>
        <LayoutBody>
          <div className={styles['form-container']}>
            <Card on style={{ width: '360px' }}>
              <ResetPasswordForm token={token} />
            </Card>
          </div>
        </LayoutBody>
      </Layout>
    </div>
  )
}

export default ResetPasswordPage
